import React from 'react'
import { Layout, Dropdown, Space, message } from 'antd'
import { UserOutlined, DownOutlined, MenuOutlined } from '@ant-design/icons'
import { useMsal } from '@azure/msal-react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { clearUser, logout as logoutThunk, setLoggingOut } from '../features/auth/authSlice'
import { loginRequest } from '../config/authConfig'
import eyLogo from '../assets/ey-logo.png'

const { Header: AntHeader } = Layout

const Header = ({ hideUserSection = false }) => {
  const { instance } = useMsal()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { user } = useSelector((state) => state.auth)

  const handleLogout = async () => {
    // Security Finding 8.6 - Proper session termination via redirect flow.
    // Show full-screen overlay IMMEDIATELY so no intermediate route (e.g.
    // /login from PrivateRoute, or the /logout landing page) is rendered
    // between the click and the browser navigating to AAD. The overlay is
    // driven by Redux `isLoggingOut` and rendered at App level.
    dispatch(setLoggingOut(true))
    try {
      // Note: do NOT dispatch clearUser here - that would un-authorize
      // PrivateRoute and cause a flash of /login before AAD navigation.
      // Storage is wiped inside logoutThunk just before logoutRedirect.
      await dispatch(logoutThunk()).unwrap()
      // Page navigates away to AAD; code below only runs if redirect failed.
    } catch (error) {
      console.error('MSAL logout failed:', error)
      // Fallback - finish cleanup locally and land on /logout
      dispatch(clearUser())
      dispatch(setLoggingOut(false))
      navigate('/logout', { replace: true })
    }
  }

  const handleLoginDifferentUser = async () => {
    // Same overlay treatment to avoid flicker before AAD redirect
    dispatch(setLoggingOut(true))
    dispatch(clearUser())
    localStorage.removeItem('access_token')
    localStorage.removeItem('user')
    try {
      await instance.loginRedirect({
        ...loginRequest,
        prompt: 'select_account',
      })
      // Page navigates away to AAD
    } catch (e) {
      console.error('Switch user redirect failed:', e)
      dispatch(setLoggingOut(false))
      navigate('/login?method=manual')
      message.info('Please sign in with a different account')
    }
  }

  const userMenuItems = [
    {
      key: 'switch-user',
      label: 'Login with Different User',
      icon: <UserOutlined />,
      onClick: handleLoginDifferentUser,
    },
    {
      key: 'logout',
      label: 'Logout',
      onClick: handleLogout,
    },
  ]

  return (
    <AntHeader
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px',
        background: '#000',
        height: '56px',
        borderBottom: '3px solid #FFE600',
      }}
    >
      {/* Left side - Menu Icon, Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        {/* EY Logo */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src={eyLogo} 
            alt="EY Logo" 
            style={{ height: '40px' }} 
          />
        </div>
      </div>

      {/* Right side - App Title and User Menu */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
        {/* App Title */}
        <div
          style={{
            color: '#fff',
            fontSize: '15px',
            fontWeight: '600',
          }}
        >
          Application Tracker
        </div>
        {!hideUserSection && (
          <Dropdown
            menu={{ items: userMenuItems }}
            trigger={['click']}
            placement="bottomRight"
          >
            <Space
              style={{
                cursor: 'pointer',
                color: '#fff',
                padding: '6px 12px',
                borderRadius: '4px',
                transition: 'background-color 0.3s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent'
              }}
            >
              <UserOutlined style={{ fontSize: '14px' }} />
              <span style={{ fontSize: '14px' }}>{user?.name || user?.username || 'Kallol Roy'}</span>
              <DownOutlined style={{ fontSize: '10px' }} />
            </Space>
          </Dropdown>
        )}
      </div>
    </AntHeader>
  )
}

export default Header